import { useEffect, useRef, useState } from "react";


function usePoller(callback: () => void, delay: number) {
  const savedCallback = useRef<() => void>();
  const [isPolling, setIsPolling] = useState<boolean>(true);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      if (savedCallback.current) {
        savedCallback.current();
      }
    }
    if (delay !== null && isPolling) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay, isPolling]);

  return [() => setIsPolling(true), () => setIsPolling(false)];
}

export default usePoller;
